import { Component } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'fnsr-icons',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './icons.component.html'
})
export class IconsComponent {

  icons: IconProp[] = [
    ['fad', 'user'],
    ['fad', 'user-unlock'],
    ['fad', 'user-lock'],
    ['fad', 'lock-open'],
    ['fad', 'envelope'],
    ['fad', 'lock'],
    ['fad', 'id-badge'],
    ['fad', 'address-card'],
    ['fad', 'graduation-cap'],
    ['fad', 'file-alt'],
    ['fad', 'info'],
    ['fad', 'phone-slash'],
    ['fad', 'pencil'],
    ['fad', 'pencil-alt'],
    ['fad', 'clipboard'],
    ['fad', 'heart'],
    ['fad', 'circle-notch'],
    ['fad', 'check'],
    ['fad', 'question'],
    ['fad', 'exclamation'],
    ['fad', 'exclamation-triangle'],
    ['fad', 'sync'],
    ['fad', 'sync-alt'],
    ['fad', 'calendar-alt'],
    ['fad', 'book-user'],
    ['fad', 'trash'],
    ['fad', 'trash-can']
  ]

}
